var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { deDE, enUS, frFR, itIT } from '@mui/x-date-pickers/locales';
import { useTranslation } from 'react-i18next';
var MUI_LOCALES = { de: deDE, en: enUS, fr: frFR, it: itIT };
// MUI's own locale packs cover the screen-reader labels; the visible title and buttons come
// from our messages, since MUI's Italian ("Cancellare", "Sgomberare") reads wrong.
export function usePickerLocaleText() {
    var _a;
    var _b = useTranslation('core'), t = _b.t, i18n = _b.i18n;
    var muiLocale = (_a = MUI_LOCALES[i18n.language]) !== null && _a !== void 0 ? _a : enUS;
    return __assign(__assign({}, muiLocale.components.MuiLocalizationProvider.defaultProps.localeText), { datePickerToolbarTitle: t('dateField.title'), timePickerToolbarTitle: t('timeField.title'), cancelButtonLabel: t('buttons.cancel'), okButtonLabel: t('buttons.ok'), clearButtonLabel: t('dateField.buttons.clear'), todayButtonLabel: t('dateField.buttons.today') });
}
